import { api, attachAuthOptions } from '../../../utils/api';
import { favoritesEndpoints } from './config';
import { FavoriteKind } from './types';

const { CATEGORY: CATEGORY_ENDPOINT, FILE: FILE_ENDPOINT } = favoritesEndpoints;
export const addFavorite = async (id: number, kind: FavoriteKind) => {
  const endpoint = kind === 'category' ? CATEGORY_ENDPOINT : FILE_ENDPOINT;
  return api.post(`${endpoint}/${id}/favorites/`, {}, attachAuthOptions());
};

export const removeFavorite = async (id: number, kind: FavoriteKind) => {
  const endpoint = kind === 'category' ? CATEGORY_ENDPOINT : FILE_ENDPOINT;
  return api.delete(`${endpoint}/${id}/favorites`, attachAuthOptions());
};
